/* TAGO MAGO theme JS */
(function () {
  'use strict';
  var T = window.theme || {};
  var R = T.routes || {};
  var S = T.strings || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || 'Rs. {{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fm(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return d + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(re);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fm(cents, 0); break;
      case 'amount_with_comma_separator': value = fm(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fm(cents, 0, '.', ','); break;
      default: value = fm(cents, 2);
    }
    return format.replace(re, value);
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-drawer-overlay]');

  function openDrawer() {
    if (!drawer) { window.location.href = R.cart; return; }
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = !cart.item_count;
    });
    var body = $('[data-cart-items]');
    var foot = $('[data-cart-foot]');
    var title = $('[data-cart-title]');
    if (!body) return;
    if (title) title.textContent = 'Cart • ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>' + esc(S.cartEmpty) + '</p><a class="btn" href="' + esc(R.allProducts) + '">' + esc(S.continueShopping) + '</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cart-item__var">' + esc(it.variant_title) + '</div>' : '';
      var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2')) + '" alt="' + esc(it.product_title) + '" width="72" height="72">' : '<div></div>';
      return '<div class="cart-item" data-key="' + esc(it.key) + '">' + img +
        '<div><a class="cart-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="qty"><button type="button" data-qty-change="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-qty-change="1" aria-label="Increase">+</button></div>' +
        '<div><button type="button" class="link-btn" data-remove>' + esc(S.remove) + '</button></div></div>' +
        '<div class="price">' + formatMoney(it.final_line_price) + '</div></div>';
    }).join('');
    var total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.items_subtotal_price);
    if (foot) foot.hidden = false;
  }

  function fetchCart() {
    return fetch(R.cartJson, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, qty) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-open]')) {
      e.preventDefault();
      fetchCart().then(openDrawer);
      return;
    }
    if (t.closest('[data-cart-close]') || t === overlay) { closeDrawer(); return; }

    var line = t.closest('.cart-item');
    if (line) {
      var key = line.getAttribute('data-key');
      var ch = t.closest('[data-qty-change]');
      if (ch) {
        var cur = parseInt($('.qty span', line).textContent, 10) || 1;
        changeLine(key, Math.max(0, cur + parseInt(ch.getAttribute('data-qty-change'), 10)));
        return;
      }
      if (t.closest('[data-remove]')) { changeLine(key, 0); return; }
    }

    /* quantity steppers on product forms */
    var step = t.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('.qty');
      var input = $('input', wrap);
      var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
      return;
    }

    /* Buy now */
    var buy = t.closest('[data-buy-now]');
    if (buy) {
      e.preventDefault();
      var f = buy.closest('form');
      addToCart(f, true, buy);
      return;
    }

    /* sticky bar add */
    var st = t.closest('[data-sticky-add]');
    if (st) {
      var main = $('[data-product-form][data-main-form]');
      if (main) { if (main.requestSubmit) main.requestSubmit(); else { var sb = $('[data-add-btn]', main); if (sb) sb.click(); } }
      return;
    }

    /* gallery thumbs */
    var th = t.closest('[data-thumb]');
    if (th) {
      var g = th.closest('[data-gallery]');
      var idx = th.getAttribute('data-thumb');
      $$('[data-slide]', g).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === idx); });
      $$('[data-thumb]', g).forEach(function (b) { b.classList.toggle('is-active', b === th); });
      return;
    }

    /* mobile menu */
    if (t.closest('[data-menu-toggle]')) {
      var nav = $('[data-site-nav]');
      if (nav) nav.classList.toggle('is-open');
      return;
    }
    /* search */
    if (t.closest('[data-search-toggle]')) {
      var sbar = $('[data-search-bar]');
      if (sbar) { sbar.hidden = !sbar.hidden; var inp = $('input', sbar); if (!sbar.hidden && inp) inp.focus(); }
      return;
    }
    /* announcement close */
    if (t.closest('[data-ann-close]')) {
      var bar = t.closest('[data-countdown-bar]');
      if (bar) bar.hidden = true;
      return;
    }
    /* back to top */
    if (t.closest('[data-back-to-top]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Add to cart ---------- */
  function addToCart(form, buyNow, btn) {
    if (!form) return;
    var idInput = $('[name="id"]', form);
    if (!idInput || !idInput.value) return;
    var errEl = $('[data-form-error]', form);
    if (errEl) errEl.textContent = '';
    var buttons = $$('[data-add-btn],[data-buy-now],[data-sticky-add]');
    buttons.forEach(function (b) { b.disabled = true; });

    var fd = new FormData(form);
    fetch(R.cartAdd, { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || S.error);
        }
        if (buyNow) { window.location.href = R.checkout; return; }
        return fetchCart().then(function () {
          if (document.body.getAttribute('data-open-drawer') !== 'false') openDrawer();
        });
      })
      .catch(function (err) {
        if (errEl) errEl.textContent = err.message || S.error;
        else alert(err.message || S.error);
      })
      .then(function () {
        if (!buyNow) updateAvailability();
        buttons.forEach(function (b) { if (!b.hasAttribute('data-keep-disabled')) b.disabled = false; });
        updateAvailability();
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-product-form]') : null;
    if (!form) return;
    e.preventDefault();
    addToCart(form, false);
  });

  /* ---------- Variants ---------- */
  var variantsEl = $('[data-variants-json]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
  var currentVariant = null;

  function selectedOptions() {
    var vals = [];
    $$('[data-option-index]').forEach(function (fs) {
      var checked = $('input:checked', fs);
      vals[parseInt(fs.getAttribute('data-option-index'), 10)] = checked ? checked.value : null;
    });
    return vals;
  }
  function findVariant() {
    if (!variants) return null;
    var sel = selectedOptions();
    if (!sel.length) return variants[0];
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return sel[i] === o; });
    })[0] || null;
  }
  function updateAvailability() {
    if (!variants) return;
    var v = currentVariant || findVariant();
    var addBtns = $$('[data-add-btn],[data-sticky-add]');
    var buyBtns = $$('[data-buy-now]');
    var label = $('[data-add-label]');
    var ok = v && v.available;
    addBtns.forEach(function (b) {
      b.disabled = !ok;
      if (b.hasAttribute('data-add-btn')) b.textContent = !v ? 'Unavailable' : (ok ? (b.getAttribute('data-label') || S.addToCart) : S.soldOut);
    });
    buyBtns.forEach(function (b) { b.disabled = !ok; });
  }
  function onVariantChange() {
    var v = findVariant();
    currentVariant = v;
    var idInput = $('[data-variant-id]');
    if (v && idInput) idInput.value = v.id;
    $$('[data-price]').forEach(function (el) {
      if (!v) return;
      el.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ' <s>' + formatMoney(v.compare_at_price) + '</s>' : '');
    });
    if (v && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    if (v && v.featured_image_id) {
      var slide = $('[data-slide][data-media-id="' + v.featured_image_id + '"]');
      if (slide) {
        var idx = slide.getAttribute('data-slide');
        var th = $('[data-thumb="' + idx + '"]');
        if (th) th.click();
      }
    }
    updateAvailability();
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-option-index]')) onVariantChange();
  });
  if (variants) { currentVariant = findVariant(); updateAvailability(); }

  /* ---------- Sticky add-to-cart ---------- */
  var sticky = $('[data-sticky]');
  var anchor = $('[data-add-btn]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var below = en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !en.isIntersecting && below);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Countdown: looping timer (hours) or fixed end date (Pakistan time) ---------- */
  var cdBar = $('[data-countdown-bar]');
  if (cdBar) {
    var loopH = parseFloat(cdBar.getAttribute('data-loop')) || 0;
    var raw = cdBar.getAttribute('data-end');
    var end = raw ? new Date(raw.trim().replace(' ', 'T') + ':00+05:00').getTime() : NaN;
    var els = { d: $('[data-cd-d]', cdBar), h: $('[data-cd-h]', cdBar), m: $('[data-cd-m]', cdBar), s: $('[data-cd-s]', cdBar) };
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var show = function (diff) {
      els.d.textContent = pad(Math.floor(diff / 86400));
      els.h.textContent = pad(Math.floor(diff % 86400 / 3600));
      els.m.textContent = pad(Math.floor(diff % 3600 / 60));
      els.s.textContent = pad(diff % 60);
    };
    if (loopH > 0) {
      /* Loops forever: shows the time left until the next N-hour mark, then restarts. */
      var period = Math.round(loopH * 3600);
      var loopTick = function () {
        var now = Math.floor(Date.now() / 1000);
        show(period - (now % period));
      };
      loopTick();
      setInterval(loopTick, 1000);
    } else if (!isNaN(end) && end > Date.now()) {
      var tick = function () {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (diff <= 0) { cdBar.hidden = true; return false; }
        show(diff);
        return true;
      };
      tick();
      var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
    } else {
      cdBar.hidden = true;
    }
  }

  /* ---------- Rotating announcement messages ---------- */
  var msgs = $$('.ann-msg');
  if (msgs.length > 1) {
    var mi = 0;
    setInterval(function () {
      msgs[mi].classList.remove('is-active');
      mi = (mi + 1) % msgs.length;
      msgs[mi].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Delivery estimate dates ---------- */
  var dEl = $('[data-delivery-dates]');
  if (dEl) {
    var from = parseInt(dEl.getAttribute('data-from'), 10) || 2;
    var to = parseInt(dEl.getAttribute('data-to'), 10) || 4;
    var mon = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var ord = function (n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };
    var fmtD = function (days) {
      var d = new Date(); d.setDate(d.getDate() + days);
      return mon[d.getMonth()] + ' ' + ord(d.getDate());
    };
    dEl.textContent = fmtD(from) + ' - ' + fmtD(to);
  }

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var track = $('[data-hero-track]', hero);
    var slides = $$('[data-hero-slide]', hero);
    if (slides.length < 2) return;
    var dots = $$('[data-hero-dot]', hero);
    var i = 0, timer;
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    };
    var auto = parseInt(hero.getAttribute('data-autoplay'), 10);
    var start = function () { if (auto > 0) timer = setInterval(function () { go(i + 1); }, auto * 1000); };
    var stop = function () { clearInterval(timer); };
    hero.addEventListener('click', function (e) {
      if (e.target.closest('[data-hero-prev]')) { stop(); go(i - 1); start(); }
      if (e.target.closest('[data-hero-next]')) { stop(); go(i + 1); start(); }
      var dt = e.target.closest('[data-hero-dot]');
      if (dt) { stop(); go(dots.indexOf(dt)); start(); }
    });
    go(0); start();
  });

  /* ---------- Back to top visibility ---------- */
  var btt = $('[data-back-to-top]');
  if (btt) {
    window.addEventListener('scroll', function () { btt.hidden = window.scrollY < 400; }, { passive: true });
  }

  /* ---------- Init ---------- */
  fetchCart();
})();
